type Props = {
  extension: Oneflow.Extension;
  className?: string;
};

export const ExtensionLogo = ({ extension, className }: Props) => {
  let logo = extension.assets?.logo;

  if (!logo) {
    // Same URL for all envs, do not use environment specific URLs
    logo = 'https://static.oneflow.com/marketplace/default-logo.svg';
  }

  return (
    <img
      alt="logo"
      src={logo}
      className={className}
    />
  );
};
